<template>
  <div >
      <iframe :src="iframeUrl"></iframe>
  </div>
</template>

<script>

export default {
  data() {
    return {
      iframeUrl: ""
    };
  },
  computed: {
  },
  created() {},
  methods: {
    //iframe地址
    getIframeUrl() {
      this.iframeUrl =  "https://view.officeapps.live.com/op/view.aspx?src=" +
          JSON.parse(localStorage.getItem("jump")).url;
      console.log("this.iframeUrl",this.iframeUrl)
    },
  },
  mounted(){
    this.getIframeUrl();
  },
  watch: {
  }
};
</script>

<style lang="less" rel="stylesheet/less">
iframe {
  width: 100%;
  height: 100%;
  min-height: 500px;
  border: 1px solid #f4f8f9;
}
.lightBlue {
  color: #66b1ff;
}
</style>


// WEBPACK FOOTER //
// src/components/teachingContent/PPTPlay.vue